import { NETWORK_APEX_DOMAIN } from "@framework/config";
import { getTenantIdFromNetwork } from "@framework/config/community/notifications/tenants";
import { makeRequest } from "@framework/notifications/request";
import { AnyNotification } from "@voxmedia/duet-context/context/notifications-context";

interface MutationResponse {
  markRead: AnyNotification[];
}

const mutation = /* GraphQL */ `
  mutation MarkRead($ids: [String!], $all: Boolean) {
    markRead(ids: $ids, all: $all) {
      id
      type
      createdAt
      seen
      read
      source
    }
  }
`;

/**
 * Marks notifications as read via Notifications Service.
 */
export async function markNotificationsAsRead(params: {
  token: string;
  ids?: string[];
  all?: boolean;
  tenantId?: string;
  serverURL?: string;
}): Promise<AnyNotification[]> {
  const {
    token,
    ids,
    all = false,
    tenantId = getTenantIdFromNetwork(NETWORK_APEX_DOMAIN),
    serverURL = process.env.NEXT_PUBLIC_NOTIFICATIONS_SERVICE_URL,
  } = params;

  if (!tenantId) {
    throw new Error(
      `markNotificationsAsRead: no tenant mapped for network "${NETWORK_APEX_DOMAIN}"`,
    );
  }

  if (!serverURL) {
    throw new Error("Missing config value for Notifications Service URL.");
  }

  const apiURL = new URL("/api", serverURL).toString();

  const response = await makeRequest<MutationResponse>(
    apiURL,
    mutation,
    {
      ids,
      all,
      tenantId,
    },
    token,
  );

  if (!response.data) {
    throw new Error("Failed to mark notifications as read.");
  }

  return response.data.markRead;
}
